module.exports = __webpack_public_path__ + "static/media/amex-dining.1d5e46cb.png";